"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const AntBoardLoader_1 = require("../../../problems/santa-fe/AntBoardLoader");
const CGPGenerator_1 = require("../../../cgp/CGPGenerator");
const RegularCGPExecutor_1 = require("../../../cgp/RegularCGPExecutor");
const CGPPointMutator_1 = require("../../../cgp/CGPPointMutator");
exports.default = () => {
    const cgpConfig = {
        numInputs: 2,
        numMiddleNodes: 100,
        numOutputs: 2,
        nodeInputCount: 2,
        operators: [
            ([x, y]) => {
                return x && y;
            },
            ([x, y]) => {
                return x || y;
            },
            ([x, y]) => {
                return x && !y;
            },
            ([x, y]) => {
                return x !== y;
            },
            ([x, y]) => {
                return !x;
            },
        ],
    };
    const generator = new CGPGenerator_1.CGPGenerator(cgpConfig);
    const mutator = new CGPPointMutator_1.CGPPointMutator(cgpConfig);
    const pool = Array.from({ length: 5 }, (_, i) => generator.generate());
    //let parent = pool[0];
    const [antBoard, setAntBoard] = React.useState(null);
    const [bestScore, setBestScore] = React.useState(0);
    const [parent, setParent] = React.useState(pool[0]);
    const [generation, setGeneration] = React.useState(1);
    function renderControls(board) {
        return (React.createElement("div", null,
            React.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    let currentPoolBest = 0;
                    for (let i = 0; i < pool.length; i++) {
                        board.reset();
                        const executor = new RegularCGPExecutor_1.RegularCGPExecutor(pool[i], cgpConfig);
                        for (let turn = 0; turn < 400; turn++) {
                            const input = executor.execute(board.getState());
                            board.executeAction(input[0], input[1]);
                        }
                        const score = board.foodGathered;
                        if (score > currentPoolBest) {
                            currentPoolBest = score;
                            setParent(pool[i]);
                        }
                    }
                    setBestScore(currentPoolBest);
                }) }, "Measure Best"),
            "Best score: ",
            bestScore,
            "Generation: ",
            generation,
            React.createElement("br", null),
            React.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    pool[0] = parent;
                    for (let i = 1; i < pool.length; i++) {
                        pool[i] = mutator.mutate(parent);
                    }
                    setGeneration(generation + 1);
                }) }, "Build next generation"),
            React.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    let i = 0;
                    let localParent = parent;
                    let localGeneration = generation;
                    (function run() {
                        return __awaiter(this, void 0, void 0, function* () {
                            // Nice part is we already have the fitnesses:
                            pool[0] = localParent;
                            for (let i = 1; i < pool.length; i++) {
                                pool[i] = mutator.mutate(localParent);
                            }
                            let currentPoolBest = 0;
                            for (let i = 0; i < pool.length; i++) {
                                board.reset();
                                const executor = new RegularCGPExecutor_1.RegularCGPExecutor(pool[i], cgpConfig);
                                for (let turn = 0; turn < 400; turn++) {
                                    const input = executor.execute(board.getState());
                                    board.executeAction(input[0], input[1]);
                                }
                                const score = board.foodGathered;
                                if (score > currentPoolBest) {
                                    currentPoolBest = score;
                                    localParent = pool[i];
                                    setParent(pool[i]);
                                }
                            }
                            setBestScore(currentPoolBest);
                            localGeneration++;
                            setGeneration(localGeneration);
                            i++;
                            if (i < 100) {
                                setTimeout(run, 0);
                            }
                            else {
                            }
                        });
                    })();
                }) }, "Run 100 generations")));
    }
    return (React.createElement("div", null,
        React.createElement("p", null, "This post is to demonstrate that regular CGP cannot solve the problem as is. The CGP implementation has been modified to use boolean operations (AND, OR, XOR, NOT, etc). We will also be using elite selection, point mutation, and 4 children."),
        React.createElement("p", null, "The best score is 11, which is: If there's food in front, go straight, otherwise turn (doesn't matter which direction). This solution gets the ant through the first two turns in the trail, but fails upon encountering the first gap, at which point it will always spin (it never sees food in front of it due to the gap)."),
        antBoard === null && (React.createElement("button", { type: "button", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                const board = yield (0, AntBoardLoader_1.loadFromUrl)("/data/santa-fe-ant-trail.csv");
                setAntBoard(board);
            }) }, "Load Trail")),
        antBoard !== null && renderControls(antBoard)));
};
